import React from 'react';
import SupplierProfile from '../components/supplier-profile'

const SupplierProfilePage = (props) => {
	const { supplierId } = props.match.params;
	return (
		<SupplierProfile  supplierId={supplierId}/>
	)
}

export default SupplierProfilePage;


// WEBPACK FOOTER //
// ./src/containers/supplier-profile-page.js